import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=342bd594"
import script from "./SortIcon.vue?vue&type=script&lang=ts"
export * from "./SortIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('342bd594')) {
      api.createRecord('342bd594', component.options)
    } else {
      api.reload('342bd594', component.options)
    }
    module.hot.accept("./SortIcon.vue?vue&type=template&id=342bd594", function () {
      api.rerender('342bd594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/SortIcon.vue"
export default component.exports